<!-- 底部导航 -->
<template>
  <div class="footer">
    <div class="footerTop">
      <div class="left">
        <img src="../assets/images/logo.png" />
        <span>江苏绿茶网络科技有限公司</span>
      </div>
      <div class="right">
        <img src="../assets/images/ewm.jpg" />
        <span>关注绿茶科技</span>
      </div>
    </div>
    <div class="footerCenter">
      <!-- <p @click="callPhone('0516-83893365')">固话：0516-83893365</p> -->
      <p>邮箱：xzwbllm@qq.com</p>
      <!-- <p>地址：徐州市泉山区软件园路6号徐州软件园C-2-A号楼901-903室</p> -->
      <!-- <p>QQ客服：<a target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">绿前：VIki</a> 丨
        <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=289366266&site=qq&menu=yes">绿中：小慧</a>
      </p> -->

      <button @click="callPhone('400-6616-831')">400-6616-831</button>
      <a class="btna" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
      <span>服务咨询（9:00-17:30）</span>
    </div>
    <div class="footerBottom">
      <p>
        江苏绿茶网络科技有限公司 版权所有 <a href="https://beian.miit.gov.cn">苏ICP备14030286号-3</a>
        <br />电信增值经营许可证ICP：苏B2-20150149
        <br />在线大数据处理许可证EDI： 苏B2-20150149
      </p>
      <span>
        <img src="../assets/images/putOn.png" /> 苏公安网安备 32031102001009号
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},

  methods: {
    // 调用拨号功能
    callPhone(phoneNumber) {
      window.location.href = "tel:" + phoneNumber;
    },
  },
};
</script>
<style lang='less' scoped>
.footer {
  background-color: transparent;
  margin-top: -0.8rem;
  .footerTop {
    height: 2.88rem;
    background: url("../assets/images/foot_bg01.png") no-repeat center top
      transparent;
    background-size: 100% auto;
    padding-top: 0.6rem;
    display: flex;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    .left {
      padding: 1rem 0 0 0.4rem;
      line-height: 0.5rem;
      height: 1.6rem;
      display: flex;
      align-items: center;
      width: 7.8rem;
      img {
        width: 0.6rem;
        height: 0.6rem;
      }
      span {
        font-size: 0.38rem;
        color: #d8d9df;
        padding-left: 0.15rem;
      }
    }
    .right {
      flex: 1;
      width: 2.2rem;
      text-align: center;
      padding-right: 0.7rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
      }
      span {
        display: block;
        font-size: 0.26rem;
        color: #9ea0af;
        padding-top: 0.1rem;
      }
    }
  }
  .footerCenter {
    padding: 0 0.4rem;
    margin-top: -0.3rem;
    background-color: #262e43;
    color: #afb1bc;
    border-bottom: 1px solid #3c4356;
    p {
      font-size: 0.3rem;
      line-height: 0.6rem;
      position: relative;
      z-index: 2;
    }
    a {
      color: #afb1bc;
    }
    .btna {
      height: 1.2rem;
      display: block;
      width: 100%;
      border: 1px solid green;
      font-size: 0.4rem;
      color: #fff;
      border-radius: 0.1rem;
      font-weight: bold;
      margin-top: 0.3rem;
      font-family: Arial, Helvetica, sans-serif;
      text-align: center;
      line-height: 1.2rem;
      color: green;
    }
    button {
      height: 1.2rem;
      display: block;
      width: 100%;
      border: 1px solid #ddd;
      font-size: 0.4rem;
      color: #fff;
      border-radius: 0.1rem;
      font-weight: bold;
      margin-top: 0.3rem;
      font-family: Arial, Helvetica, sans-serif;
    }
    span {
      text-align: center;
      font-size: 0.26rem;
      display: block;
      padding: 0.3rem 0 0.3rem;
    }
  }
  .footerBottom {
    background-color: #262e43;
    padding: 0.4rem 0;
    p {
      font-size: 0.3rem;
      color: #7d818c;
      line-height: 0.6rem;
      text-align: center;
      transform: scale(0.94);
    }
    a {
      color: #fff;
    }
    span {
      text-align: center;
      font-size: 0.3rem;
      color: #7d818c;
      transform: scale(0.94);
      display: block;
      img {
        width: 0.4rem;
        margin-top: -0.05rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/comFooter.vue